import React, { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { I18nProvider } from "@/i18n";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LandingPage from "@/landing/LandingPage";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import InvitePage from "@/pages/InvitePage";
import AppLayout from "@/app/AppLayout";
import Dashboard from "@/app/Dashboard";
import Transactions from "@/app/Transactions";
import RecurringPage from "@/app/RecurringPage";
import Banks from "@/app/Banks";
import Cari from "@/app/Cari";
import Payments from "@/app/Payments";
import Receivables from "@/app/Receivables";
import BudgetsPage from "@/app/BudgetsPage";
import Reports from "@/app/Reports";
import TeamPage from "@/app/TeamPage";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="grid min-h-screen place-items-center bg-[#FDFDFD]">
          <p className="text-sm text-slate-500">Bir şeyler ters gitti — sayfayı yenileyin.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Loading() {
  return (
    <div className="grid min-h-screen place-items-center bg-[#FDFDFD]">
      <span className="h-8 w-8 animate-spin rounded-full border-2 border-slate-200 border-t-slate-900" />
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/giris" replace />;
  return children;
}

function GuestOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user) {
    const davet = new URLSearchParams(window.location.search).get("davet");
    return <Navigate to={davet ? `/davet/${davet}` : "/app"} replace />;
  }
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/giris" element={<GuestOnly><Login /></GuestOnly>} />
      <Route path="/kayit" element={<GuestOnly><Register /></GuestOnly>} />
      <Route path="/davet/:token" element={<InvitePage />} />
      <Route path="/app" element={<Protected><AppLayout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="islemler" element={<Transactions />} />
        <Route path="tekrarlayan" element={<RecurringPage />} />
        <Route path="bankalar" element={<Banks />} />
        <Route path="cari" element={<Cari />} />
        <Route path="odemeler" element={<Payments />} />
        <Route path="tahsilatlar" element={<Receivables />} />
        <Route path="butceler" element={<BudgetsPage />} />
        <Route path="raporlar" element={<Reports />} />
        <Route path="ekip" element={<TeamPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <ScrollToTop />
            <AppRoutes />
            <Toaster richColors position="top-right" />
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
